<template>
  <div>
    <v-progress-circular v-if="isLoadingOrders" indeterminate color="white" size="18" width="2"></v-progress-circular>
    <v-menu v-else-if="pendingOrders && pendingOrders.length > 0" bottom left offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-badge color="red" overlap>
            <template slot="badge">
              <span>{{ pendingOrders.length }}</span>
            </template>
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list two-line>
        <template v-for="(order, index) in pendingOrders">
          <v-list-item :key="order.id" :to="{ name: 'order', params: { id: order.id } }">
            <v-list-item-action>
              <v-list-item-action-text class="list-date">{{
                order.issuedAt | moment('from', 'now') | capitalize
              }}</v-list-item-action-text>
            </v-list-item-action>
            <v-list-item-content class="list-date-content">
              <v-list-item-title>{{ $t('message.notification.pending_payment') }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $t('message.notification.pending_payment_description', {
                  site: order.connectAgreement.site.name,
                  servicePlan: order.connectAgreement.servicePlan.name
                })
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index + 1 < pendingOrders.length" :key="index" class="my-2"></v-divider>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import fetch from '@/utils/fetch'

export default {
  name: 'ToolbarApps',

  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  data() {
    return {
      isLoadingOrders: false
    }
  },

  computed: {
    pendingOrders: {
      get() {
        return this.$store.state.pendingOrders.orders
      },
      set(val) {
        this.$store.commit('pendingOrdersSetOrders', val)
      }
    }
  },

  watch: {
    pendingOrders(pendingOrders) {
      if (null === pendingOrders) {
        this.fetchPendingOrders()
      }
    }
  },

  mounted() {
    this.fetchPendingOrders()
  },

  methods: {
    fetchPendingOrders: function() {
      this.pendingOrders = null
      this.isLoadingOrders = true
      fetch('/orders?order[issuedAt]=desc&pagination=false&status=pending&exists[connectAgreement]=true')
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.pendingOrders = data['hydra:member']
          this.isLoadingOrders = false
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log(e)
          this.isLoadingOrders = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-btn {
  margin: 0;
  width: 80px;
  height: 110px;

  img {
    height: 40px;
  }
}

.list-date {
  max-width: 70px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.list-date-content {
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
